import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../utils/FirebaseConfig';

const PaymentSuccess = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const updatePaymentStatus = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const email = urlParams.get('email');
            const billplzId = urlParams.get('billplz_id');

            if (!email || !billplzId) {
                console.error("❌ Missing email or billplz_id in query params.");
                return;
            }

            try {
                console.log("✅ Processing payment success for email:", email);

                const q = query(collection(db, 'submitters'), where('emailMasjid', '==', email));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const userDoc = querySnapshot.docs[0].ref;
                    await updateDoc(userDoc, {
                        status: "pending_review", // ✅ Update status after payment
                        billplz_id: billplzId,
                        payment_date: new Date()
                    });

                    console.log("✅ Payment recorded successfully for:", email);
                    navigate('/status'); // Redirect to check status
                } else {
                    console.error("❌ No user found with email:", email);
                }
            } catch (error) {
                console.error("❌ Error updating payment status:", error);
            }
        };

        updatePaymentStatus();
    }, [navigate]);

    return (
        <div>
            <h2>Payment Successful</h2>
            <p>Processing your payment confirmation...</p>
        </div>
    );
};

export default PaymentSuccess;
